// Hauteurs des composants individuels
export const HEADER_BAND_HEIGHT = {
  base: '50px',
  md: '40px',
} as const;

export const NAVBAR_HEIGHT = '65px';

// Hauteur totale du header (HeaderBand + Navbar)
export const HEADER_HEIGHT = {
  base: `calc(${HEADER_BAND_HEIGHT.base} + ${NAVBAR_HEIGHT})`,
  md: `calc(${HEADER_BAND_HEIGHT.md} + ${NAVBAR_HEIGHT})`,
} as const;

// Hauteur des onglets MesProduitsApp
export const TABS_HEIGHT = {
  base: '48px',
  md: '52px',
} as const;
